import SpendExplorationIcon from "../../../../components/icons/svg/ChartMagnifierIcon.svg?react";
import CategoryAnalysisIcon from "../../../../components/icons/svg/FlowChartIcon.svg?react";
import SupplierNormalizationIcon from "../../../../components/icons/svg/StoreIcon.svg?react";
import TailSpendAnalysisIcon from "../../../../components/icons/svg/TrendDownGraphIcon.svg?react";
import ConsolidationDeepDiveIcon from "../../../../components/icons/svg/MergeRightIcon.svg?react";
import StatdLogoIcon from '~/icons/logo/StadaLogo.svg?react';

const ICONS = {
    spend_exploration: <SpendExplorationIcon width={20} height={20}/>,
    supplier_deep_dive: <SupplierNormalizationIcon width={20} height={20}/>,
    category_analysis: <CategoryAnalysisIcon width={20} height={20}/>,
    tail_spend_analysis: <TailSpendAnalysisIcon width={20} height={20}/>,
    consolidation_deep_dive: <ConsolidationDeepDiveIcon width={20} height={20}/>,
    stada_templates: <StatdLogoIcon width={24} height={14}/>,
};

export function TemplatesIcon({name}: {name: string}) {
    return ICONS[name as keyof typeof ICONS] ?? null;
}
